






























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import DurasiJamMenit from "./DurasiJamMenit.vue";

@Component({ components: { DurasiJamMenit } })
export default class SectionKala2 extends Vue {
  @Prop({ required: true }) value!: any;
  local: any = {};

  pendampingOpts = ["Bidan", "Suami", "Keluarga", "Teman", "Dukun", "Tidak ada"];

  @Watch("value", { immediate: true, deep: true })
  onValueChange(v: any) {
    const vStr = JSON.stringify(v || {});
    if (JSON.stringify(this.local) === vStr) return;
    this.local = JSON.parse(vStr);
    if (!Array.isArray(this.local.gawat_janin_tindakan) || this.local.gawat_janin_tindakan.length < 3) {
      this.local.gawat_janin_tindakan = ["", "", ""];
    }
    if (!Array.isArray(this.local.distosia_tindakan) || this.local.distosia_tindakan.length < 3) {
      this.local.distosia_tindakan = ["", "", ""];
    }
  }

  @Watch("local", { deep: true })
  emitInput(v: any) {
    this.$emit("input", v);
  }
}
